(function () {
	const DESKTOP_MIN_WIDTH = 1100;
	// Headers whose hover/focus/scroll listeners are already bound
	const boundHeaders = new WeakSet();
	// Latest observed content-box width per header (one shared ResizeObserver)
	const headerWidths = new WeakMap();
	const headerResizeObserver =
		typeof ResizeObserver === "function"
			? new ResizeObserver((entries) => {
					entries.forEach((entry) => {
						headerWidths.set(entry.target, entry.contentRect.width);
					});
			  })
			: null;

	const getHeaderWidth = (header) => {
		if (headerWidths.has(header)) return headerWidths.get(header);
		const styles = window.getComputedStyle(header);
		return (
			header.clientWidth -
			(parseFloat(styles.paddingLeft) || 0) -
			(parseFloat(styles.paddingRight) || 0)
		);
	};

	let annBarObserver = null;

	const bindHeaderListeners = (header) => {
		if (boundHeaders.has(header)) return;
		boundHeaders.add(header);

		if (headerResizeObserver) headerResizeObserver.observe(header);

		const isDesktop = () => getHeaderWidth(header) >= DESKTOP_MIN_WIDTH;

		const addBackground = () => {
			if (document.querySelector(".overflow-hidden-drawer")) {
				return;
			}

			if (document.querySelector(".always-show")) {
				return;
			}

			if (!isDesktop()) return;

			if (
				header.classList.contains("color-background-2") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.remove("color-background-2");
			}

			if (
				header.classList.contains("section--have-overlay") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.add("have-background");
			}
		};

		const removeBackground = () => {
			if (
				document.querySelector(".overflow-hidden") ||
				document.querySelector(".overflow-hidden-drawer")
			) {
				return;
			}

			if (document.querySelector(".always-show")) {
				return;
			}

			if (!isDesktop()) return;

			if (
				header.classList.contains("color-background-1") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.add("color-background-2");
			}

			if (
				header.classList.contains("section--have-overlay") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.remove("have-background");
			}
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);

		const observeFirstSection = () => {
			const firstSection = document.querySelector(
				"main .shopify-section:first-child:not(.not-margin) .section--has-overlay:not(.article-template__header)"
			);
			let isSectionVisible = false;
			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting && !isSectionVisible) {
						isSectionVisible = true;
						header.classList.add("entering-section", "color-background-2");
					} else if (!entry.isIntersecting && isSectionVisible) {
						isSectionVisible = false;
						header.classList.remove("entering-section");
					}
				},
				{ threshold: 0.15 }
			);

			if (firstSection) {
				observer.observe(firstSection);
			}

			window.addEventListener(
				"scroll",
				() => {
					if (isSectionVisible) {
						header.classList.add("entering-section", "color-background-2");
					}
				},
				{ passive: true }
			);
		};

		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", observeFirstSection);
		} else {
			observeFirstSection();
		}
	};

	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		if (!header) return;

		const headerAlways = document.querySelector(".header-always");

		if (headerAlways) {
			header.classList.add("always-show");
		}

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		const annBar = document.querySelector(".section-announcement");
		if (annBarObserver) annBarObserver.disconnect();
		annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.intersectionRect.height}px`
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		bindHeaderListeners(header);

		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		const firstMainSection = main?.querySelectorAll(".shopify-section")[0];
		if (
			firstMainSection?.classList.contains("section--has-overlay") &&
			!firstMainSection?.classList.contains("not-margin")
		) {
			header.classList.add("color-background-1", "color-background-2");
			if (breadcrumbs) {
				breadcrumbs.classList.add("color-background-2");
			}
		}
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
